import React, { PureComponent } from 'react';
import Modal from 'react-modal';
import '../css/SystemIntegratorView.css';
import SIOkasBoxes from './SIOkasBoxes';
import Cookies from 'js-cookie';
import Sorting from './Sorting';


//si project details  page
const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    minheight: '10%',
    maxheight: '50%',
    overflow: 'auto',
    padding: '40px 90px 40px 90px',
    marginLeft: '260px',
    marginTop: '3%',
    background: '#EFF3F6',
    // background: 'none !important'
  },
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "none"
  },
};

export default class SIProjects extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      modalIsOpen: this.props.activeModal,
      modalShowOkasBox: false,
      modalStateAftereOpen: 'animated animated-duration-custom slideInDown',
      SiUsername: this.props.siCurrentData.si_userName,
      SiName: this.props.siCurrentData.si_name,
      errorMessage: [],
      currentBuilding: '',
      siAllProjectData: this.props.siAllProjectData,
      actualData: this.props.siAllProjectData,
      sortingStatus: {
        sortingName: '',
        defaultDown: true
      },
      someElement: ''
    };
    this.openModal = this.openModal.bind(this);
    this.afterOpenModal = this.afterOpenModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  openModal() {
    this.setState({ modalIsOpen: true });
  }

  afterOpenModal() {

  }

  closeModal() {
    this.setState({
      modalStateAftereOpen: 'animated animated-duration-custom slideOutUp'
    }, () => {
      setTimeout(() => {
        this.setState({
          modalIsOpen: false,
        }, () => this.props.closeAllModal())
      }, 500);
    })
  }

  componentWillMount() {
    this.AllProjects()
  }
  renderOkasBoxes = () => {
    if (this.state.modalShowOkasBox) {
      console.log(this.state)
      return (
        <SIOkasBoxes activeModal={true} siCurrentData={this.props.siCurrentData} buildingId={this.state.currentBuilding} />
      )
    } else {
      return null
    }
  }

  restoreData = (data) => {
    this.setState({
      siAllProjectData: data,
    }, () => {
      this.AllProjects()
    })
  }


  AllProjects = () => {
    let element = this.state.siAllProjectData.map((e) => {
      console.log('data1',this.state.siAllProjectData)
      return <tr>
        <td style={{ width: '150px' }}>{e.building_id}</td>
        <td>{e.building_name}</td>
        <td>{e.owner_name}</td>
        <td>{e.address}</td>
        <td>{e.total_number_of_okas_box}</td>
        <td><span className="fa fa-download" style={{cursor: e.file===null ? 'not-allowed' :  e.file.length===0 ? 'not-allowed' : 'pointer',color: e.file===null ? '#ccc' : e.file.length===0 ? '#ccc' : '#00AEA7',  }} data-toggle={e.file===null ? '' : e.file.length===0 ? 'tooltip' : 'dfg'} title={ e.file===null ? 'Project configuration is in progress' : e.file.length===0 ? "Project configuration is in progress": ''} data-placement="left"
          onClick={() => {
            var tokenStored = localStorage.getItem('token');
            tokenStored = `Token ${tokenStored}`
            if(e.file!==null){
              if( e.file.length!==0){
                fetch(`/cloud/projectPdf?building_id=${e.building_id}`, {
                  method: "GET",
                  headers: {
                    "Content-Type": "application/json",
                    "Authorization": tokenStored
                  }
              })
                       .then(response => {
              if(response.status===403){
                localStorage.removeItem('token');
                localStorage.removeItem('csrftoken');
                localStorage.removeItem('auth');
                // const history = createHistory({forceRefresh: true})
                window.location.href ='/session-timeout'
              }else{
                  return response.json()}
              })
              .then(url => {
                window.location.assign(url);
              })
              .catch((err)=>{
                console.log(err)
              }
              )
            }
            }
            }}
            ></span></td>
      </tr>
    })
    this.setState({
      someElement: element
    })
    return element;
  }

  fetchIconType = (e) => {
    if (e === this.state.sortingStatus.sortingName && this.state.sortingStatus.defaultDown) {
      return 'fas fa-chevron-down pointer ml-2 float-right'
    } else if (e === this.state.sortingStatus.sortingName && !this.state.sortingStatus.defaultDown) {
      return 'fas fa-chevron-up pointer ml-2 float-right'
    } else {
      return 'fas fa-chevron-down pointer ml-2 float-right icon-inactive'
    }
  }


  sortingFunc = (type, searchValue) => {
    if (type !== 'search') {
      if (this.state.sortingStatus.sortingName === type) {
        this.setState({
          sortingStatus: {
            sortingName: type,
            defaultDown: !this.state.sortingStatus.defaultDown
          },
        }, () => {
          if (this.state.sortingStatus.sortingName === type && this.state.sortingStatus.defaultDown) {
            Sorting(this.restoreData, type, this.state.actualData);
          } else if (this.state.sortingStatus.sortingName === type && !this.state.sortingStatus.defaultDown) {
            Sorting(this.restoreData, 'reverse', this.state.siAllProjectData);
          }
        })
      } else {
        this.setState({
          sortingStatus: {
            sortingName: type,
            defaultDown: true
          },
        }, () => {
          if (this.state.sortingStatus.sortingName === type && this.state.sortingStatus.defaultDown) {
            Sorting(this.restoreData, type, this.state.actualData);
          } else if (this.state.sortingStatus.sortingName === type && !this.state.sortingStatus.defaultDown) {
            Sorting(this.restoreData, 'reverse', this.state.siAllProjectData);
          }
        })
      }
    } else if (type === 'search') {
      type = 'search';
      Sorting(this.restoreData, type, this.state.actualData, searchValue);
    } else {
      type = 'reverse';
      Sorting(this.restoreData, type, this.state.actualData);
    }
  }

  render() {
    return (
      <React.Fragment>
        {this.renderOkasBoxes()}
        <Modal
          isOpen={this.state.modalIsOpen}
          onAfterOpen={this.afterOpenModal}
          className={this.state.modalStateAftereOpen}
          style={customStyles}
          contentLabel="Example Modal"
        >
          <div className="modal-add-device">
            <div className="float-right cross-times" onClick={this.closeModal}>
              <i class="fas   fa-2x mr-2"></i>
            </div>
          </div>
          <h3 className="modal-heading text-uppercase mb-0 mt-4" style={{ color: '#888888', fontSize: '30px' }} >{this.state.SiName}'s Project Details</h3>
          <div className="" style={{ marginTop: '30px' }}>
            <table className="table">
              <thead className="tableHeaderColor" style={{ borderRadius: '10px 10px 0px 0px' }}>
                <th scope="col" style={{ width: '150px' }}>
                  Building ID
                    <i class={this.fetchIconType('building_id')} onClick={(e) => { this.sortingFunc('building_id') }}>
                  </i>
                </th>
                <th scope="col">
                  Building Name
                    <i class={this.fetchIconType('building_name')} onClick={(e) => { this.sortingFunc('building_name') }}>
                  </i>
                </th>
                <th scope="col">
                  Owner Name
                    <i class={this.fetchIconType('owner_name')} onClick={(e) => { this.sortingFunc('owner_name') }}>
                  </i>
                </th>
                <th scope="col">
                  Building Address
                    <i class={this.fetchIconType('address')} onClick={(e) => { this.sortingFunc('address') }}>
                  </i>
                </th>
                <th scope="col">
                  No of OKAS Boxes
                    <i class={this.fetchIconType('total_number_of_okas_box')} onClick={(e) => { this.sortingFunc('total_number_of_okas_box') }}>
                  </i>
                </th>
                <th>
                  Download
                </th>
              </thead>
              <tbody style={{ height: '313px' }}>
                {/* {this.AllProjects()}*/}
                {this.state.someElement}
              </tbody>
            </table>
            <div className="row w-100 mt-4" style={{ marginLeft: '0', marginRight: '0' }}>
              <div className="float-right ml-auto">
                <div className="btn btn-new-grey" onClick={this.closeModal}>Close</div>
              </div>
            </div>
          </div>
        </Modal>
      </React.Fragment>
    );
  }
}
